import { Utils } from '@everyboard/lib';
import { Player, PlayerOrNone } from '../../jscaip/Player';
export class GoPiece {
    player;
    type;
    static DARK = new GoPiece(Player.ZERO, 'alive');
    static LIGHT = new GoPiece(Player.ONE, 'alive');
    static EMPTY = new GoPiece(PlayerOrNone.NONE, 'empty');
    static DEAD_DARK = new GoPiece(Player.ZERO, 'dead');
    static DEAD_LIGHT = new GoPiece(Player.ONE, 'dead');
    static DARK_TERRITORY = new GoPiece(Player.ZERO, 'territory');
    static LIGHT_TERRITORY = new GoPiece(Player.ONE, 'territory');
    static UNREACHABLE = new GoPiece(PlayerOrNone.NONE, 'unreachable'); // For Triangular Go and Hexagonal Go
    static isReachable(piece) {
        return piece.isReachable();
    }
    constructor(player, type) {
        this.player = player;
        this.type = type;
    }
    equals(other) {
        return other === this;
    }
    toString() {
        switch (this) {
            case GoPiece.DARK:
                return 'GoPiece.DARK';
            case GoPiece.LIGHT:
                return 'GoPiece.LIGHT';
            case GoPiece.EMPTY:
                return 'GoPiece.EMPTY';
            case GoPiece.DEAD_DARK:
                return 'GoPiece.DEAD_DARK';
            case GoPiece.DEAD_LIGHT:
                return 'GoPiece.DEAD_LIGHT';
            case GoPiece.DARK_TERRITORY:
                return 'GoPiece.DARK_TERRITORY';
            case GoPiece.UNREACHABLE:
                return 'GoPiece.UNREACHABLE';
            default:
                Utils.assert(this === GoPiece.LIGHT_TERRITORY, 'Unexisting GoPiece');
                return 'GoPiece.LIGHT_TERRITORY';
        }
    }
    static pieceBelongTo(piece, owner) {
        return owner === piece.player && piece.type !== 'territory';
    }
    static ofPlayer(player) {
        if (player === Player.ZERO) {
            return GoPiece.DARK;
        }
        else {
            return GoPiece.LIGHT;
        }
    }
    isOccupied() {
        return this.type === 'alive' ||
            this.type === 'dead';
    }
    isEmpty() {
        return this.type === 'territory' ||
            this.type === 'empty';
    }
    isDead() {
        return this.type === 'dead';
    }
    isTerritory() {
        return this.type === 'territory';
    }
    getOwner() {
        return this.player;
    }
    nonTerritory() {
        Utils.assert(this.isEmpty(), 'Usually not false, if false, cover by test and return "this"');
        return GoPiece.EMPTY;
    }
    isReachable() {
        return this.type !== 'unreachable';
    }
}
